import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import AuthLayout, { AuthNotice } from './Auth/AuthLayout';
import { authErrorKey } from '../utils/authFlow';

export default function ForgotPassword() {
  const { t } = useTranslation('auth');
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const submit = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError(''); setSent(false);
    try {
      auth.languageCode = language;
      await sendPasswordResetEmail(auth, email.trim());
      setSent(true);
    } catch (err) {
      if (err.code === 'auth/user-not-found') setSent(true);
      else setError(authErrorKey(err));
    } finally { setBusy(false); }
  };
  return <AuthLayout title={t('forgotPassword.title')} subtitle={t('forgotPassword.subtitle')}
    footer={<Link to="/login">{t('forgotPassword.backToLogin')}</Link>}>
    <AuthNotice>{error && t(error)}</AuthNotice>
    <AuthNotice success>{sent && t('forgotPassword.successMessage')}</AuthNotice>
    <form aria-labelledby="auth-title" className="auth-form" onSubmit={submit} aria-busy={busy}>
      <div className="auth-field"><label htmlFor="email">{t('forgotPassword.email')}</label>
        <input id="email" name="email" type="email" autoComplete="email" autoCapitalize="none" spellCheck="false" dir="ltr" required
          value={email} onChange={e => { setEmail(e.target.value); setSent(false); }} disabled={busy} placeholder="name@company.com" />
      </div>
      <button className="auth-primary" type="submit" disabled={busy || sent}>{t(busy ? 'forgotPassword.sending' : 'forgotPassword.button')}</button>
    </form>
  </AuthLayout>;
}
